import { Table } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { CheckCircleOutlined } from "@ant-design/icons";
import { dateFromString } from "../../../utils/dateFromString";
import { formatCurrency } from "../../../utils/formatCurrency";
import { Factura } from "./_Factura";
import { Complemento } from "./_Complemento";
import { Comprobante } from "./_Comprobante";
import { ModalOrdenPago } from "./modalOrdenPago/ModalOrdenPago";

export const Listado = () => {
  const { ordenesAbiertas } = useSelector((state) => state.facturacionReducer);

  const columns = [
    {
      title: 'Orden de Pago',
      dataIndex: 'ordenPagoID',
      key: 'ordenPagoID',
      render: (ordenPagoID, record) => (
        <ModalOrdenPago
          ordenPagoID={ordenPagoID}
          texto={`${ordenPagoID} (${record.asistencias?.length || 0})`}
        />
      ),
    },
    {
      title: 'Monto',
      dataIndex: 'total',
      key: 'total',
      sorter: (a, b) => a.total - b.total,
      render: (total) => formatCurrency(total),
    },
    {
      title: 'Creación',
      dataIndex: 'fechaCreacion',
      key: 'fechaCreacion',
      sorter: (a, b) => new Date(a.fechaCreacion) - new Date(b.fechaCreacion),
      render: (fecha) => dateFromString(fecha).soloFecha,
    },
    {
      title: 'Autorización',
      dataIndex: 'fechaAutorizacionPago',
      key: 'fechaAutorizacionPago',
      sorter: (a, b) => {
        if (!a.fechaAutorizacionPago) return 1;
        if (!b.fechaAutorizacionPago) return -1;
        return new Date(a.fechaAutorizacionPago) - new Date(b.fechaAutorizacionPago);
      },
      render: (fecha) => dateFromString(fecha).soloFecha,
    },
    {
      title: 'Factura',
      key: 'factura',
      render: (_, record) => <Factura orden={record} />,
    },
    {
      title: 'Validación',
      dataIndex: 'facturaEsValida',
      key: 'facturaEsValida',
      render: (facturaEsValida) => facturaEsValida ? <CheckCircleOutlined style={{ color: 'green', fontSize: 18 }} /> : '',
    },
    {
      title: 'Pago',
      key: 'pago',
      render: (_, record) => <Comprobante orden={record} />,
    },
    {
      title: 'Complemento',
      key: 'complemento',
      render: (_, record) => <Complemento orden={record} />,
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={ordenesAbiertas}
      rowKey="ordenPagoID"
      pagination={false}
      locale={{ emptyText: 'Sin registros' }}
      style={{ marginTop: 10 }}
    />
  );
};
